import { render, staticRenderFns } from "./BindingWizardModalControl.global.vue?vue&type=template&id=1c23c207&lang=pug&"
import script from "./BindingWizardModalControl.global.vue?vue&type=script&lang=ts&"
export * from "./BindingWizardModalControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports